import { LOAD_SUBMISSION_TYPES } from '../actionTypes';

const loadSubmissionTypes = (payload) => ({
  type: LOAD_SUBMISSION_TYPES,
  payload: payload || [],
});

export { loadSubmissionTypes }; //eslint-disable-line



// WEBPACK FOOTER //
// ./src/redux/actions/utilities.js